<app-preview-bar *ngIf="isPreview"></app-preview-bar>

<ng-template [ngIf]="globalHeader !== null">

	<!-- This example requires Tailwind CSS v2.0+ -->
<div class="relative bg-white ">
  <div class="max-w-7xl mx-auto">
    <div class="relative z-10 bg-white lg:max-w-2xl lg:w-full">
      <svg class="hidden lg:block absolute right-0 inset-y-0 h-full w-48 text-white transform translate-x-1/2" fill="currentColor" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
        <polygon points="50,0 100,0 50,100 0,100" />
      </svg>

      <div class="relative pt-6 px-4 sm:px-6 lg:px-8">
        <nav class="relative flex items-center justify-between sm:h-10 lg:justify-start" aria-label="Global">
          <div class="flex items-center flex-grow flex-shrink-0 lg:flex-grow-0">
            <div class="flex items-center justify-between w-full md:w-auto">
              <a routerLink="/" routerLinkActive="active">
                <span class="sr-only">{{ globalHeader.siteName }}</span>
                <img class="h-8 w-auto sm:h-10" [src]="globalHeader.logo.url+'?w=200'" [alt]="globalHeader.logo.label">
              </a>
              <div class="-mr-2 flex items-center md:hidden">
                <button (click)="toggle()" type="button" class="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500" id="main-menu" aria-haspopup="true">
                  <span class="sr-only">Open main menu</span>
                  <!-- Heroicon name: outline/menu -->
                  <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="hidden md:block md:ml-10 md:pr-4 md:space-x-8" *ngFor="let link of links">
             <a [routerLink]="link.url"  class="font-medium text-gray-500 hover:text-gray-900">{{link.title}}</a>
          </div>
        </nav>
      </div>


    </div>
  </div>

  <div class="absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden z-20"

  	*ngIf="showMobileMenu"
	x-show="open"
	x-transition:enter="duration-200 ease-out"
	x-transition:enter-start="opacity-0 scale-95"
	x-transition:enter-end="opacity-100 scale-100"
	x-transition:leave="duration-100 ease-in"
	x-transition:leave-start="opacity-100 scale-100"
	x-transition:leave-end="opacity-0 scale-95">
	<div class="rounded-lg shadow-lg">
		<div class="rounded-lg shadow-xs bg-white divide-y-2 divide-gray-50">
		<div class="pt-5 pb-6 px-5 space-y-6">
			<div class="flex items-center justify-between">
			<div>
				<img class="h-8 w-auto sm:h-10" [src]="globalHeader.logo.url+'?w=200'" [alt]="globalHeader.logo.label">
			</div>
			<div class="-mr-2">
				<button (click)="toggle()" type="button" class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out">
				<!-- Heroicon name: x -->
				<svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
				</svg>
				</button>
			</div>
			</div>
			<div>
			<nav class="grid gap-y-8" *ngFor="let link of links">

				<a [routerLink]="link.url" (click)="mobileLink(link.url)" class="m-1 p-3 flex items-center space-x-3 rounded-md hover:bg-gray-50 transition ease-in-out duration-150">
					<!-- Heroicon name: view-grid -->
					<svg class="flex-shrink-0 h-6 w-6 text-indigo-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
					</svg>
					<div class="text-base leading-6 font-medium text-gray-900">
					{{link.title}}
					</div>
				</a>

			</nav>
			</div>
		</div>

			<!-- <div class="space-y-6 p-2">
			<span class="w-full flex rounded-md shadow-sm">

				{% if globalHeader.fields.primaryCTA %}
				<a href="{{ globalHeader.fields.primaryCTA.href }}" target="{{ globalHeader.fields.primaryCTA.target }}" class="w-full flex items-center justify-center px-4 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150">
					{{ globalHeader.fields.primaryCTA.text }}
				</a>
				{% endif %}

			</span> -->
			</div>
		</div>
	</div>
</div>




</ng-template>